import React, { useEffect, useState } from 'react'

const targetDate = new Date('2026-01-19T10:00:00')

const getTimeLeft = () => {
  const diff = Math.max(targetDate.getTime() - Date.now(), 0)
  const day = 1000 * 60 * 60 * 24
  const hour = 1000 * 60 * 60
  const minute = 1000 * 60
  return {
    days: Math.floor(diff / day),
    hours: Math.floor((diff % day) / hour),
    minutes: Math.floor((diff % hour) / minute),
    seconds: Math.floor((diff % minute) / 1000),
  }
}

export default function Countdown() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft)

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft())
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  return (
    <section className="relative bg-gradient-to-r from-sky-50 via-white to-sky-100 px-4 sm:px-6 pt-24 pb-16">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_top_right,_rgba(14,165,233,0.12),_transparent_45%)]" />
      <div className="relative max-w-6xl mx-auto text-center">
        <p className="text-lg sm:text-xl font-semibold text-sky-700 mb-3">العد التنازلي حتى بدء الملتقى</p>
        <p className="text-2xl sm:text-3xl font-bold text-slate-900 mb-8">19 يناير 2026 • الساعة 10 صباحاً</p>

        <div className="flex justify-center gap-3 sm:gap-4">
          {[
            { value: timeLeft.days, label: 'يوم' },
            { value: timeLeft.hours, label: 'ساعة' },
            { value: timeLeft.minutes, label: 'دقيقة' },
            { value: timeLeft.seconds, label: 'ثانية' },
          ].map((item) => (
            <div
              key={item.label}
              className="md:min-w-[88px] min-w-[50px] rounded-2xl bg-white shadow-[0_20px_60px_-30px_rgba(15,23,42,0.45)] border border-slate-100 px-4 py-4 text-center"
            >
              <div className="text-3xl sm:text-4xl font-black text-slate-900">{item.value}</div>
              <div className="text-sm sm:text-base font-semibold text-slate-600">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
        {/* <a
        target='_blank'
        href="https://tamkeenx.eventfull.sa/register"
        className="
          block mx-auto mt-4 w-52 rounded-full
          bg-sky-700 p-2 text-center
          text-xl sm:text-3xl font-semibold text-white
          transition-all duration-300
          hover:-translate-y-0.5
          hover:bg-sky-600
          hover:shadow-lg hover:shadow-sky-500/30
          active:translate-y-0
        "
      >
        التسجيل
      </a>
      */}
    </section>
  )
}
